// extracted by mini-css-extract-plugin
module.exports = {"paywall__form":"Paywall_paywall__form__ZObhA","paywall__button":"Paywall_paywall__button__dY7VA"};